import { CommandGetFontFamilies, FontFamily } from "./commands/cmdGetFontFamilies";
import { CommandGetFontCss } from "./commands/cmdGetFontCss";
import { CommandUploadFont } from "./commands/cmdUploadFont";
import { FontVariant } from "../../models/brand.model";

export class FontService {
    async getFontFamilies(source: string, search?: string): Promise<FontFamily[]> {
        const cmd = new CommandGetFontFamilies();
        return cmd.run(source, search);
    }

    async getFontCss(family: string, weight: number, italic: boolean): Promise<string> {
        const cmd = new CommandGetFontCss();
        return cmd.run(family, weight, italic);
    }

    async uploadFont(file: File): Promise<FontVariant> {
        const cmd = new CommandUploadFont();
        return cmd.run(file);
    }
}
